<!-- ========================= -->
<!-- Menu Button Per folder -->
<!-- ========================= -->
@if (isFolder) {
  <div>
    <button
      matTooltip="Altre azioni"
      matTooltipPosition="above"
      [matTooltipShowDelay]="500"
      (click)="$event.stopPropagation()"
      class="action-btn"
      mat-icon-button
      [matMenuTriggerFor]="menu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button class="btn-lista-menu" mat-menu-item (click)="infoFileFolder()">
        <mat-icon class="material-icons-outlined">info</mat-icon>
        <span>Dettagli</span>
      </button>
      <!-- <button class="btn-lista-menu" mat-menu-item>
        <mat-icon>bookmark</mat-icon>
        <span>Asegna TAG</span>
      </button> -->
      <button class="btn-lista-menu" mat-menu-item (click)="nuovoFolder(true)">
        <mat-icon>create_new_folder</mat-icon>
        <span>Aggiungi Cartella</span>
      </button>
      <!-- Input file nascosto -->
      <input
        #fileInputMenu
        type="file"
        multiple
        style="display: none"
        (change)="importaFile($any($event.target)?.files)"
      />

      <!-- Bottone del menu -->
      <button
        class="btn-lista-menu"
        mat-menu-item
        [disabled]="folderSelezionato?.locked"
        (click)="fileInputMenu.click()"
      >
        <mat-icon>post_add</mat-icon>
        <span>Importa documento</span>
      </button>
      <button
        class="btn-lista-menu"
        mat-menu-item
        [disabled]="folderSelezionato?.locked"
        (click)="nuovoFolder(false)"
      >
        <mat-icon>edit</mat-icon>
        <span>Rinomina</span>
      </button>

      <mat-divider></mat-divider>
      <button
        class="btn-lista-menu btn-elimina"
        mat-menu-item
        (click)="deleteFolder()"
        [disabled]="folderSelezionato?.locked"
      >
        <mat-icon>delete</mat-icon>
        <span>Elimina</span>
      </button>
    </mat-menu>
  </div>
}
<!-- ========================= -->
<!-- Menu Button Per FILE -->
<!-- ========================= -->

@if (isFile) {
  <div>
    <button
      matTooltip="Altre azioni"
      matTooltipPosition="above"
      [matTooltipShowDelay]="500"
      (click)="$event.stopPropagation()"
      class="action-btn"
      mat-icon-button
      [matMenuTriggerFor]="menu"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button class="btn-lista-menu" mat-menu-item (click)="infoFileFolder()">
        <mat-icon class="material-icons-outlined">info</mat-icon>
        <span>Dettagli</span>
      </button>
      <!--  <button class="btn-lista-menu" mat-menu-item>
        <mat-icon>bookmark</mat-icon>
        <span>Asegna TAG</span>
      </button> -->
      <button class="btn-lista-menu" mat-menu-item (click)="downloadFile()">
        <mat-icon>cloud_download</mat-icon>
        <span>Scarica</span>
      </button>
      @if (!isModulo) {
        <button class="btn-lista-menu" mat-menu-item (click)="renameFile()">
          <mat-icon>edit</mat-icon>
          <span>Rinomina</span>
        </button>
        <mat-divider></mat-divider>
        <button class="btn-lista-menu btn-elimina" mat-menu-item (click)="deleteFile()">
          <mat-icon>delete</mat-icon>
          <span>Elimina</span>
        </button>
      }
    </mat-menu>
  </div>
}
